import { render, staticRenderFns } from "./ClassificationList.vue?vue&type=template&id=c615b87c&scoped=true&"
import script from "./ClassificationList.vue?vue&type=script&lang=ts&"
export * from "./ClassificationList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c615b87c",
  null
  
)

export default component.exports